import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom/server';
import { push } from 'react-router-redux';
import { point } from 'leaflet';
import gotFlight from '../../../shared/lib/flick/index';
import componentBase from '../../lib/component-base';
import { loadFlight as loadFlightFlick } from '../../redux/modules/flick/actions';
import { loadByCarrierFlightNumberAndDate } from '../../../modules/SingleFlight/redux/actions';

function buildAirportPopupHTML(airportData, warning) {
  let airportName = airportData.name.replace('International', 'Intl.');
  if (airportName.length > 30) {
    airportName = `${airportName.substring(0, 30)}...`;
  }
  let tempInC = '--';
  let tempInF = '--';

  if (airportData.temperatureCelsius && airportData.temperatureCelsius !== 'N/A') {
    tempInC = airportData.temperatureCelsius;
    tempInF = airportData.temperatureCelsius * 9 / 5 + 32;
  }

  const leftClassName = `left flight-tracker-icon-${warning ? 'warning' : 'standard'}-gradient-color-left`;
  const rightClassName = `right flight-tracker-icon-${warning ? 'warning' : 'standard'}-gradient-color-right`;
  const outerDivId = `map-airport-popup-click-outer_${airportData.fsCode}`;
  const innerDivId = `map-airport-popup-click-inner_${airportData.fsCode}`;
  const spanId = `map-airport-popup-click-inner-span_${airportData.fsCode}`;
  const spanStr = `Current ${airportData.fsCode} Conditions`;

  const html = (
    <div className='parent' key={airportData.fsCode}>
      <div className='details'>
        <div className={leftClassName}>
          <div>{airportData.fsCode}</div>
          <div>{airportName}</div>
          <div>{tempInF}&deg; F ({tempInC}&deg; C)</div>
        </div>
        <div className={rightClassName} />
      </div>
      <div className='sep' />
      <div id={outerDivId} className='click-to-parent'>
        <div id={innerDivId} className='click-to'>
          <span id={spanId}>{ spanStr }</span>
        </div>
      </div>
    </div>
  );

  return ReactDOM.renderToString(html);
}

@componentBase('MapFlick')
export default class MapFlick extends Component {
  static propTypes = {
    disableRefresh: PropTypes.bool,
    dispatch: PropTypes.func,
    flightId: PropTypes.number,
    map: PropTypes.object,
    params: PropTypes.object,
  };

  componentDidMount() {
    this.initMap(this.props, true);
  }


  componentWillReceiveProps(nextProps) {
    this.initMap(nextProps);
  }

  componentWillUnmount() {
    this.timer && clearInterval(this.timer);
    window.removeEventListener('click', this.pageClick);
  }

  initMap(props, force) {
    // if the flightId in the url matches the flightId in the props
    const { disableRefresh, flightId, map, params } = props;
    const { flightId: oldFlightId, params: oldParams } = this.props;
    const shouldReinit = force ||
      oldFlightId !== flightId ||
      oldParams.carrier !== params.carrier ||
      oldParams.flightNumber !== params.flightNumber ||
      oldParams.year !== params.year ||
      oldParams.month !== params.month ||
      oldParams.day !== params.day;

    if (shouldReinit) {
      this.timer && clearInterval(this.timer);
      gotFlight(
        flightId,
        map,
        this.context.store,
        loadFlightFlick,
        loadByCarrierFlightNumberAndDate,
        params,
        disableRefresh,
        ({
          departureAirportMarker,
          arrivalAirportMarker,
          divertedAirportMarker,
          edgeFlightData,
          timer,
        }) => {
          departureAirportMarker.bindPopup(
            buildAirportPopupHTML(edgeFlightData.airports.departure, false),
            { offset: point(123, 13), className: 'flight-tracker-airport-popup' },
          );
          arrivalAirportMarker.bindPopup(
            buildAirportPopupHTML(edgeFlightData.airports.arrival, false),
            { offset: point(123, 13), className: 'flight-tracker-airport-popup' },
          );
          if (divertedAirportMarker) {
            divertedAirportMarker.bindPopup(
              buildAirportPopupHTML(edgeFlightData.airports.diverted, true),
              { offset: point(123, 13), className: 'flight-tracker-airport-popup' },
            );
          }
          this.timer = timer;
        },
      );
    }

    window.addEventListener('click', this.pageClick);
  }

  pageClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (event && event.srcElement && event.srcElement.id &&
      event.srcElement.id.indexOf('map-airport-popup-click-') !== -1) {
      const clickAirportCode = event.srcElement.id.substr(event.srcElement.id.length - 3);
      const url = ['/airport-conditions/', clickAirportCode, '/'];

      this.props.dispatch(push(url.join('')));
    }
  }

  render() {
    return (<div />);
  }
}



// WEBPACK FOOTER //
// ./src/components/MapFlick/MapFlick.js